import { Component, Input, forwardRef } from '@angular/core';
import { ClientService } from '../../../services/client.service';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { AlertService } from '../../../services/alert.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
	selector: 'ztsi-client-select',
	templateUrl: './ztsi-client-select.component.html',
	styleUrls: ['./ztsi-client-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiClientSelectComponent),
			multi: true
		}
	]
})
export class ZtsiClientSelectComponent implements ControlValueAccessor {
	clients: KeyValuePair[] = [];
	
	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;
	@Input() nullLabel: string = 'Select client';

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _clientService: ClientService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._clientService.getClientsDropdownList().subscribe(response => {
			if (response.length != undefined) {
				this.clients = response;
			}
			else {
				console.log('Unable to load client selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-client-select/ztsi-client-select.component.ts